import { addFilter } from '@wordpress/hooks';

const addHoverAttributes = (settings, name) => {
  // Apply to both Cover and Image blocks
  if (name === 'core/cover' || name === 'core/image') {
    settings.attributes = {
      ...settings.attributes,
      blynexHoverEffect: {
        type: 'string',
        default: 'none',
      },
      blynexHoverIntensity: {
        type: 'number',
        default: 0.5,
      },
      blynexHoverScale: {
        type: 'number',
        default: 1.05,
      },
      blynexHoverDuration: {
        type: 'number',
        default: 0.3,
      },
    };
  }
  return settings;
};

addFilter(
  'blocks.registerBlockType',
  'blynex/hover-effect-attributes',
  addHoverAttributes,
  20
);